import { generateKeys } from '../utils';
export const alertTypes = generateKeys({
    documetsKYCThresholdExpired: {
        value: 'documetsKYCThresholdExpired',
        label: 'KYC documents expire within 14 days [Inactive]',
        timeThreshold: 14,
        disabled: true,
    },
    maxDepositLimitExceeded: {
        value: 'maxDepositLimitExceeded',
        label: 'Max deposit over EUR 15,000 in Past 24hrs',
        threshold: 15000,
    },
    ipMissmatch: {
        value: 'ipMissmatch',
        label: 'IP not Match',
    },
    missingKYCTotalDeposit: {
        value: 'missingKYCTotalDeposit',
        label: 'Missing KYC documents [Inactive]',
        disabled: true,
    },
    totalDepositsExceedNetWorth: {
        value: 'totalDepositsExceedNetWorth',
        label: 'Total deposits exceed estimated Net Income [Inactive]',
        disabled: true,
    },
    depositsExceedDeclaredAnnualIncome: {
        value: 'depositsExceedDeclaredAnnualIncome',
        label: 'YTD Deposits Exceeds Declared Annual Income',
    },
    fundsFromThirdPartyAccount: {
        value: 'fundsFromThirdPartyAccount',
        label: 'Client deposits funds from a third party card/account',
    },
    documentKYCGoingToExpire: {
        value: 'documentKYCGoingToExpire',
        label: 'KYC document is going to expire in 3 weeks',
        timeThreshold: 21,
    },
    missingKYCWithDepositExeededTimeframe: {
        value: 'missingKYCWithDepositExeededTimeframe',
        label: 'Total Deposits exist but Missing KYC Documents [Inactive]',
        timeThreshold: 14,
        disabled: true,
    },
    missingKYCNoDepositExeededTimeframe: {
        value: 'missingKYCNoDepositExeededTimeframe',
        label: 'Suspended due to missing KYC Documents [Inactive]',
        timeThreshold: 14,
        disabled: true,
    },
    kycGracePeriodOver: {
        value: 'kycGracePeriodOver',
        label: 'KYC Grace Period Over',
    },
    abusive: {
        value: 'abusive',
        label: 'Potential Abusive Client',
    },
    moreThanThreeCreditCardsUsed: {
        value: 'moreThanThreeCreditCardsUsed',
        label: 'More than 3 different credit cards used',
    },
    clientPepUsReportable: {
        value: 'clientPepUsReportable',
        label: 'Client Indicates PEP/US Reportable',
    },
    kycClientBlacklisted: {
        value: 'kycClientBlacklisted',
        label: 'Watchlist match',
    },
    dormantAccountReactivation: {
        value: 'dormantAccountReactivation',
        label: 'Dormant account reactivation',
    },
    worldCheck: {
        value: 'worldCheck',
        label: 'World Check',
    },
    crmBlacklisted: {
        value: 'crmBlacklisted',
        label: 'Blacklisted in CRM',
    },
    suspiciousActivity: {
        value: 'suspiciousActivity',
        label: 'Suspicious Activity',
    },
    dueDiligence: {
        value: 'dueDiligence',
        label: 'Due Diligence manual check',
    },
    clientCompletedDueDiligence: {
        value: 'clientCompletedDueDiligence',
        label: 'Client Completed Due Diligence',
    },
    kycGracePeriodOverRefund: {
        value: 'kycGracePeriodOverRefund',
        label: 'KYC Grace Period Over (Refund)',
    },
    usReportableOpenPositions: {
        value: 'usReportableOpenPositions',
        label: 'Client Indicates US Reportable and has Open Positions',
    },
    suspendNoCardCopies: {
        value: 'suspendNoCardCopies',
        label: 'No credit card copies provided (suspend/refund)',
    },
    heldDepositRefund: {
        value: 'heldDepositRefund',
        label: 'Held Deposit Refund',
    },
    possibleDuplicateAffiliates: {
        value: 'possibleDuplicateAffiliates',
        label: 'Possible Duplicate Lead (Affiliates)',
    },
    possibleDuplicateIBs: {
        value: 'possibleDuplicateIBs',
        label: 'Possible Duplicate Lead (IBs)',
    },
    possibleDuplicateClient: {
        value: 'possibleDuplicateClient',
        label: 'Possible Duplicate Client',
    },
    depositsExceeded15000Limit: {
        value: 'depositsExceeded15000Limit',
        label: 'Client total deposit exceeds 15,000',
        threshold: 15000,
    },
    depositsExceeded50000Limit: {
        value: 'depositsExceeded50000Limit',
        label: 'Client total deposit exceeds 50,000',
        threshold: 50000,
    },
    depositsExceeded100000Limit: {
        value: 'depositsExceeded100000Limit',
        label: 'Client total deposit exceeds 100,000',
        threshold: 100000,
    },
    riskClassificationChanged: {
        value: 'riskClassificationChanged',
        label: 'Risk Classification Changed',
    },
});
export const alertStatuses = generateKeys({
    resolved: {
        value: 'resolved',
        label: 'Resolved',
    },
    active: {
        value: 'active',
        label: 'Active',
    },
    permanentlyResolved: {
        value: 'permanentlyResolved',
        label: 'Permanently Resolved',
    },
    postponed: {
        value: 'postponed',
        label: 'Postponed',
    },
});
export const resolveAlertReasons = generateKeys({
    verified: {
        value: 'verified',
        label: 'Verified',
        comment: 'Verified',
        alerts: [alertTypes.fundsFromThirdPartyAccount.value],
    },
    autoEmail: {
        value: 'autoEmail',
        label: 'Auto Email',
        comment: 'Auto Email',
        alerts: [alertTypes.fundsFromThirdPartyAccount.value],
    },
    accountClosedRejected: {
        value: 'accountClosedRejected',
        label: 'Account Closed/Rejected',
        comment: 'Account Closed/Rejected',
        alerts: [alertTypes.fundsFromThirdPartyAccount.value],
    },
    nameMatches: {
        value: 'nameMatches',
        label: 'Name Matches',
        comment: 'Name Matches',
        alerts: [alertTypes.fundsFromThirdPartyAccount.value],
    },
    refunded: {
        value: 'refunded',
        label: 'Refunded',
        comment: 'Refunded',
        alerts: [alertTypes.fundsFromThirdPartyAccount.value],
    },
    ccIdRequested: {
        value: 'ccIdRequested',
        label: 'CC/ID Requested',
        comment: 'CC/ID Requested',
        alerts: [alertTypes.fundsFromThirdPartyAccount.value],
    },
    other: {
        value: 'other',
        label: 'Other',
    },
});
